import { colors, Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import React, { useCallback, useEffect, useState } from "react";

import CommanExcelExport from "../CommonComponents/CommanExcelExport";
import CommonTable from "../CommonComponents/CommanTable";
import EnhancedTableToolbar from "../CommonComponents/EnhancedTableToolbar";
import ExportPdf from "../CommonComponents/exportPdf";
import LoadingComponent from "../CommonComponents/loadinComponent";
import TopView from "../CommonComponents/topView";

import { isArray } from "lodash";
import { NitMasterAction } from "../../actions/NitMaster";

import moment from "moment";
import CustomHeaderModal from "../CommonComponents/CustomHeaderModal";
import { useSnackbar } from "../CommonComponents/SnackbarProvider";
import ExcelImportModalNIT from "./ExcelImportModalNIT";
import { VendorAction } from "../../actions/vendor";
import useApiFetch from "../CommonComponents/CommonFetchApi/fetchAllDropdownListApi";
const statusList = [
  { name: "Active", value: true },
  { name: "InActive", value: false },
];
function NitMaster() {
  const { fetchSiteList } = useApiFetch();

  const { showSnackbar } = useSnackbar();
  const [nitOptions, setNitOptions] = useState([]);
  const [searchTrigger, setSearchTrigger] = useState(false);

  const [nitList, setNitList] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [searchNitNo, setSearchNitNo] = useState("");
  const [exportData, setExportData] = useState([]);
  const [openToolBar, setOpenToolBar] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false); // Add this line

  const [permissionAccess, setPermissionAccess] = React.useState(
    JSON.parse(sessionStorage.getItem("data")),
  );

  const nitMasterPer = permissionAccess?.menuVisiblity?.find(
    (menu) => menu.name === "NIT_MASTER",
  );

  const [customModalOpen, setCustomModalOpen] = React.useState(false);
  const [customHeaders, setCustomHeaders] = React.useState([]);
  const [headerConfig, setHeaderConfig] = React.useState([]);
  const [isCustomHeaderApplied, setIsCustomHeaderApplied] = useState(false);
  const [status, setStatus] = useState(null);

  const [activeFilterCount, setActiveFilterCount] = useState(0);

  const [vendorList, setVendorList] = useState([]);
  const [vehicleTypeId, setVehicleTypeId] = useState("");

  const [operationList, setOpreationList] = useState({
    mineList: [],
    loadingList: [],
    unLoadingList: [],
  });

  const [siteList, setSiteList] = useState([]);
  const [categoryWiseList, setCategoryWiseList] = useState([]);

  const [selectedMineName, setSelectedMineName] = React.useState({});

  const [typeOfWorkList, setTypeOfWorkList] = useState([]);
  const [typeOfContractList, setTypeOfContractList] = useState([]);
  const [selectedTypeOfWork, setSelectedTypeOfWork] = useState({});
  const [selectedTypeOfContract, setSelectedTypeOfContract] = useState({});

  const transformContractType = (value) => {
    if (value === "LT") return "L&T";
    return value || "N/A";
  };

  const transformWorkType = (value) => {
    if (value === "LT") return "L&T";
    return value || "N/A";
  };
  const searchFilter = (value) => {
    setSearchTrigger((prev) => !prev);
  };

  const searchStatus = (value) => {
    setStatus(value);
    setSearchTrigger((prev) => !prev);
  };

  useEffect(() => {
    fetchNitList(true);
  }, [searchTrigger]);

  const onchnageTranspoter = (e) => {
    if (e) {
      setVehicleTypeId(e);
    } else {
      setVehicleTypeId("");
    }
    setSearchTrigger((prev) => !prev);
  };

  const searchMineType = (e) => {
    if (e) {
      setSelectedMineName(e);
    } else {
      setSelectedMineName("");
    }
    setSearchTrigger((prev) => !prev);
  };

  const searchTypeOfContract = (e) => {
    if (e) {
      setSelectedTypeOfContract(e);
    } else {
      setSelectedTypeOfContract("");
    }
    setSearchTrigger((prev) => !prev);
  };

  const searchTypeOfWork = (e) => {
    if (e) {
      setSelectedTypeOfWork(e);
    } else {
      setSelectedTypeOfWork("");
    }
    setSearchTrigger((prev) => !prev);
  };

  const dropdowns = [
    {
      label: `Select NIT No`,
      type: "search",
      valueKey: "nitNumber",
      value: searchNitNo,
      placeholder: "Select NIT Number",
      onChangeHandler: setSearchNitNo,
      onClickHandler: searchFilter,
    },
    // {
    //   label: `Select NIT No`,
    //   options: nitOptions || [],
    //   valueKey: "nitNumber",
    //   value: searchNitNo,
    //   placeholder: "Select NIT Number",
    //   optionKey: "nitNumber",
    //   type: "autocomplete",
    //   onChangeHandler: searchFilter,
    // },

    // {
    //   label: `Select Status`,
    //   options: statusList || [],
    //   valueKey: "name",
    //   value: status,
    //   placeholder: "Select Status",
    //   optionKey: "name",
    //   type: "autocomplete",
    //   onChangeHandler: searchStatus,
    // },
    {
      label: `Select Transporter`,
      options: vendorList || [],
      valueKey: "name",
      value: vehicleTypeId,
      placeholder: "Select Transporter",
      optionKey: "name",
      // optionalOptionKey: "name",
      type: "autocomplete",
      onChangeHandler: onchnageTranspoter,
    },
    {
      label: `Select Mine Name`,
      options: operationList?.mineList || [],
      valueKey: "name",
      value: selectedMineName,
      placeholder: "Select Mine Name",
      optionKey: "name",
      type: "autocomplete",
      onChangeHandler: searchMineType,
    },

    {
      label: `Select Type of Contract`,
      options: typeOfContractList || [],
      valueKey: "value",
      value: selectedTypeOfContract,
      placeholder: "Select Type of Contract",
      optionKey: "label",
      type: "autocomplete",
      onChangeHandler: searchTypeOfContract,
    },
    {
      label: `Select Type of Work`,
      options: typeOfWorkList || [],
      valueKey: "value",
      value: selectedTypeOfWork,
      placeholder: "Select Type of Work",
      optionKey: "label",
      type: "autocomplete",
      onChangeHandler: searchTypeOfWork,
    },
  ].filter(Boolean);

  useEffect(() => {
    let count = 0;
    if (searchNitNo) count++;
    if (status) count++;
    if (vehicleTypeId) count++;
    // if (selectedMineName) count++;
    // if (selectedTypeOfContract) count++;
    // if (selectedTypeOfWork) count++;

    if (selectedMineName && Object.keys(selectedMineName).length > 0) count++;
    if (
      selectedTypeOfContract &&
      Object.keys(selectedTypeOfContract).length > 0
    )
      count++;
    if (selectedTypeOfWork && Object.keys(selectedTypeOfWork).length > 0)
      count++;
    setActiveFilterCount(count);
  }, [
    searchNitNo,
    status,
    vehicleTypeId,
    selectedMineName,
    selectedTypeOfContract,
    selectedTypeOfWork,
  ]);

  useEffect(() => {
    const savedConfig = sessionStorage.getItem("nitMasterTableHeaders");
    if (savedConfig) {
      try {
        const parsedConfig = JSON.parse(savedConfig);
        const visibleHeaders = parsedConfig.filter(
          (header) => header.isVisible,
        );
        const defaultVisibleCount = labelHeader.filter((h) => h.isShow).length;

        setIsCustomHeaderApplied(
          visibleHeaders.length > 0 &&
            visibleHeaders.length !== defaultVisibleCount,
        );
      } catch (error) {
        console.error("Error loading header configuration:", error);
        setIsCustomHeaderApplied(false);
      }
    }
  }, []);

  const handleSaveHeaderConfig = (newConfig) => {
    let cleanConfig;
    try {
      cleanConfig = JSON.parse(
        JSON.stringify(newConfig, (key, value) => {
          if (
            key.startsWith("_") ||
            typeof value === "function" ||
            key === "icon" ||
            key === "isIcon"
          ) {
            return undefined;
          }
          return value;
        }),
      );
    } catch (error) {
      console.error("Error cleaning config:", error);
      return;
    }

    const visibleHeaders = cleanConfig.filter((header) => header.isVisible);
    setCustomHeaders(visibleHeaders);
    setHeaderConfig(cleanConfig);

    setIsCustomHeaderApplied(
      visibleHeaders.length > 0 &&
        visibleHeaders.length !== labelHeader.filter((h) => h.isShow).length,
    );

    try {
      sessionStorage.setItem(
        "nitMasterTableHeaders",
        JSON.stringify(cleanConfig),
      );
    } catch (error) {
      console.error("Error saving to sessionStorage:", error);
    }
  };

  useEffect(() => {
    const savedConfig = sessionStorage.getItem("nitMasterTableHeaders");
    if (savedConfig) {
      try {
        const parsedConfig = JSON.parse(savedConfig);
        const updatedConfig = parsedConfig.map((item) => {
          const original = labelHeader.find(
            (lh) => lh.keyName === item.keyName,
          );
          if (original) {
            return {
              ...original,
              ...item,
              isSorting: original.isSorting,
              sortType: original.sortType,
            };
          }
          return item;
        });
        const visibleHeaders = updatedConfig.filter(
          (header) => header.isVisible,
        );
        setCustomHeaders(visibleHeaders);
        setHeaderConfig(updatedConfig);
      } catch (error) {
        console.error("Error loading header configuration:", error);
        const defaultConfig = labelHeader.map((header, index) => ({
          ...header,
          order: index,
          isVisible: header.isShow !== false,
        }));
        setCustomHeaders(labelHeader.filter((header) => header.isShow));
        setHeaderConfig(defaultConfig);
      }
    } else {
      const defaultConfig = labelHeader.map((header, index) => ({
        ...header,
        order: index,
        isVisible: header.isShow !== false,
      }));
      const defaultVisible = labelHeader.filter((header) => header.isShow);
      setCustomHeaders(defaultVisible);
      setHeaderConfig(defaultConfig);
    }
  }, []);

  useEffect(() => {
    // fetchNitOptionsForDropdown();

    fetchVendorList();
    fetchSiteList(setSiteList, setCategoryWiseList, setOpreationList);

    fetchTypeOfWorkList();
    fetchTypeOfContractList();
  }, []);

  const fetchTypeOfWorkList = async () => {
    const workRes = await NitMasterAction.getAllWorkTypes(showSnackbar);

    const workList = workRes || [];

    setTypeOfWorkList(
      workList.map((item) => ({
        label: item.name,
        value: item,
      })),
    );
  };
  const fetchTypeOfContractList = async () => {
    const contractRes = await NitMasterAction.getAllContractTypes(showSnackbar);

    // ✅ FIX: handle direct array response
    const contractList = contractRes || [];

    setTypeOfContractList(
      contractList.map((item) => ({
        label: item.name,
        value: item,
      })),
    );
  };
  const labelHeader = [
    { name: "S. No", keyName: "sNo", isShow: true, isExportShow: true },
    {
      name: "NIT Number",
      keyName: "nitNo",
      isShow: true,
      isDetails: true,
      showAllDeatails: [{ name: "nitNo" }],
      isExportShow: true,
      isView: true,
      url: "addNit",
      type: "view",
      showImage: false,
      selectedNit: true,
      isSorting: true,
      sortType: "nitNo",
      color: "rgb(20, 146, 230)",
      urlKey: "id",
    },
    {
      name: "Mine Name",
      keyName: "mineName",
      isShow: true,
      isExportShow: true,
      isSorting: true,
      sortType: "mineName",
    },
    {
      name: "Transporter Name",
      keyName: "vendorName",
      isShow: true,
      isExportShow: true,
      isSorting: true,
      sortType: "vendorName",
    },
    {
      name: "Transporter Full Name",
      keyName: "officialName",
      isShow: true,
      isExportShow: true,
      isSorting: true,
      sortType: "officialName",
    },

    {
      name: "Type of Contract",
      keyName: "nitTypeOfContract",
      isShow: true,
      isExportShow: true,
      isSorting: true,
      sortType: "nitTypeOfContract",
    },

    {
      name: "Type of Work",
      keyName: "nitTypeOfWork",
      isShow: true,
      isExportShow: true,
    },

    {
      name: "Date of commencement",
      keyName: "issueDate",
      isShow: true,
      isExportShow: true,
      isDate: true,
      isSeconde: false,
      isNoTime: true,
    },
    {
      name: "Date of Completion",
      keyName: "expiryDate",
      isShow: true,
      isExportShow: true,
      isDate: true,
      isSeconde: false,
      isNoTime: true,
    },

    // {
    //   name: "Mine Name",
    //   keyName: "mineName",
    //   isShow: true,
    //   isExportShow: true,
    // },
    // {
    //   name: "Vendor Name",
    //   keyName: "vendorName",
    //   isShow: true,
    //   isExportShow: true,
    // },

    // {
    //   name: "Vendor Name (Vehicle Count)",
    //   keyName: "vendorCount",
    //   isShow: true,
    //   isExportShow: true,
    //   isVendorDetails: true,
    //   newTab: true,
    // },
    {
      name: "CPD/TPD",
      keyName: "cpdOrTpd",
      isShow: true,
      isExportShow: true,
    },

    {
      name: "Maximum Lead Distance",
      keyName: "maximumLeadDistance",
      isShow: true,
      isExportShow: true,
    },
    {
      name: "Total Vehicle Count",
      keyName: "vehicleCount",
      isShow: true,
      isExportShow: true,
      color: "rgb(20, 146, 230)",
      isClickHandler: true,
      url: "vehiclelist",
      isDetails: true,
      showAllDeatails: [{ name: "vehicleCount" }],
      newTab: true,
      type: "view",
      passURLSearchParams: "mineId",
      passURLSearchParams2: "transporterId",
      passURLSearchParams3: "mineName",
      passURLSearchParams4: "transporterName",
      isView: false,
    },
    {
      name: "Status",
      keyName: "isActive",
      isShow: true,
      isExportShow: true,
      isActive: true,
    },
  ];

  const getExportData = (type) => {
    fetchNitList(false, type);
  };

  const fetchNitList = useCallback(
    async (type, exportType) => {
      try {
        setLoading(true);

        const payload = {
          nitNumber: searchNitNo?.trim() || "",
          isActive: status ? status?.value : "",
          vendorId: vehicleTypeId ? vehicleTypeId?.id : "",
          mineId: selectedMineName ? selectedMineName?.id : "",
          typeOfContract: selectedTypeOfContract
            ? { id: selectedTypeOfContract?.value?.id }
            : null,

          typeOfWork: selectedTypeOfWork
            ? { id: selectedTypeOfWork?.value?.id }
            : null,
        };

        console.log("yashnitpayload", payload);
        const response = await NitMasterAction.fetchNitList(
          payload,
          showSnackbar,
        );
        console.log("allnit", response);
        if (!response) {
          setNitList([]);
          setLoading(false);
          return;
        }

        // Access the data from the response object
        const responseData = response.data || [];

        if (type) {
          const mappedData = extractNitData(responseData);

          setNitList(mappedData);
        } else {
          const mappedData = extractNitData(responseData);
          setExportData(mappedData);

          const triggerExport = (elementId) => {
            const el = document.getElementById(elementId);
            if (el) el.click();
          };

          setTimeout(() => {
            if (exportType === "excel") {
              triggerExport("styleExportExcel");
            } else if (exportType === "pdf") {
              triggerExport("exportPdfButton");
            }
          }, 300);
        }
      } catch (error) {
        console.error("Error fetching NIT list:", error);
        setNitList([]);
      } finally {
        setLoading(false);
      }
    },
    [
      searchNitNo,
      showSnackbar,
      status,
      vehicleTypeId,
      selectedMineName,
      selectedTypeOfContract,
      selectedTypeOfWork,
    ],
  );

  // const fetchNitOptionsForDropdown = useCallback(async () => {
  //   try {
  //     const payload = {
  //       nitNumber: "",
  //       isActive: "",
  //       vendorId: "",
  //       mineId: "",
  //       typeOfContract: null,
  //       typeOfWork: null,
  //       isforDrop: true,
  //     };

  //     const response = await NitMasterAction.fetchNitList(
  //       payload,
  //       showSnackbar,
  //     );

  //     if (!response) {
  //       setNitOptions([]);
  //       return;
  //     }
  //     console.log("fetchNitOptionsForDropdown", response.data);
  //     setNitOptions(response.data || []);
  //   } catch (error) {
  //     console.error("Error fetching NIT options for dropdown:", error);
  //     setNitOptions([]);
  //   }
  // }, [showSnackbar]);

  const fetchVendorList = async (mineId, areaId) => {
    let sideIds = [];
    if (
      JSON.parse(sessionStorage.getItem("data")).sites &&
      JSON.parse(sessionStorage.getItem("data")).sites.length > 0
    ) {
      JSON.parse(sessionStorage.getItem("data")).sites.forEach((element) => {
        sideIds.push(element.id);
      });
    }
    await VendorAction.fetchVendorList(
      {
        pageNo: 0,
        pageSize: 0,
        companyId: JSON.parse(sessionStorage.getItem("data")).companyId,
        companyName: "",
        isActive: "",
        name: "",
        siteIds: sideIds,
        userId: JSON.parse(sessionStorage.getItem("data")).id,
        mineId: mineId,
        areaId: areaId,
      },
      showSnackbar,
    ).then((response) => {
      if (response != null) {
        setVendorList(response);
      } else {
        setVendorList([]);
      }
    });
  };
  const extractNitData = (data) => {
    if (!Array.isArray(data)) return [];

    return data.map((item, index) => {
      return {
        sNo: index + 1,
        id: item.id || null,
        nitNo: item.nitNumber || "N/A",
        issueDate: item.issueDate,
        expiryDate: item.expiryDate,
        vehicleCount: item.vehicleCount || 0,
        isActive: item.isActive,
        nitTypeOfContract: item.typeOfContract?.name || "N/A",
        nitTypeOfWork: item.typeOfWork?.name || "N/A",
        cpdOrTpd: item.cpdOrTpd || 0,
        maximumLeadDistance: item.maximumLeadDistance || "N/A",
        mineName: item.mineName || "N/A",
        vendorName: item.vendorName || "N/A",
        officialName: item?.vendor?.officialName || "N/A",
        vendorId: item?.vendor?.id || "",
        mineId: item?.mine?.id || "",
      };
    });
  };

  const toggleOpenToolBar = () => {
    setOpenToolBar(!openToolBar);
  };

  const onAdddNit = () => {
    window.open("./addNit", "_self");
  };

  const openExcelImportModal = () => {
    setImportModalOpen(true);
  };

  const handleImportSuccess = () => {
    setSearchTrigger((prev) => !prev);
  };

  const topViewData = {
    title: "NIT Master",
    subTitleFirst: "Dashboard >",
    subTitleThird: "NIT Master",
    buttonIcon: true,
    backPath: "/dashboard",
    backPathSecond: "/dashboard",
    addButtonPath: "/add-nit",
    addButton: false,
    addCancelClick: "",
    addClick: "",
    addButtonPermission: nitMasterPer?.addPermission,
    export: true,
    showPdfButton: nitMasterPer?.exportPermission,
    showExcelButton: nitMasterPer?.exportPermission,
    getExportData: getExportData,
    openToolBar,
    toggleOpenToolBar,
    customheader: true,
    setCustomModalOpen,
    isCustomHeaderApplied: isCustomHeaderApplied,
    hasActiveFilters: activeFilterCount > 0,
    activeFilterCount: activeFilterCount,
    buttonIcon: true,
    buttonText: " Add NIT",
    ButtonClick: onAdddNit,
    addButtonPath: "/addNit",
    importBuuton: false,
    importText: " Import NITs",
    openExcelImportModal: openExcelImportModal,
  };

  return (
    <div className="makeStylesRoot" style={{ position: "relative" }}>
      <LoadingComponent isLoading={isLoading} />
      <Container>
        <TopView data={topViewData} />

        <div style={{ display: "none" }}>
          <CommanExcelExport
            headers={
              customHeaders.length > 0
                ? customHeaders
                : labelHeader.filter((h) => h.isShow)
            }
            rows={isArray(exportData) ? exportData : [exportData]}
            exportHeading={["NIT Master List"]}
            reportType={"NIT Master List"}
          />
          <ExportPdf
            headers={
              customHeaders.length > 0
                ? customHeaders
                : labelHeader.filter((h) => h.isShow)
            }
            rows={exportData || []}
            title="NIT Master List"
            reportName="nitMasterList"
          />
        </div>

        <EnhancedTableToolbar
          dropdowns={dropdowns}
          drawerOpen={openToolBar}
          setDrawerOpen={setOpenToolBar}
          onFilterChange={() => {}}
        />

        <Grid className="tableSection">
          <CommonTable
            headers={
              customHeaders.length > 0
                ? customHeaders
                : labelHeader.filter((h) => h.isShow)
            }
            rows={nitList || []}
            isShowPagination={false}
            pageNo={0}
            pageSize={0}
            updateRowData={setNitList}
          />
        </Grid>
      </Container>
      <CustomHeaderModal
        open={customModalOpen}
        onClose={() => setCustomModalOpen(false)}
        headers={labelHeader}
        onSave={handleSaveHeaderConfig}
        currentConfig={headerConfig}
      />

      <ExcelImportModalNIT
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
    </div>
  );
}

export default NitMaster;
